import { timelineItems } from "../content/roadshow";

export function Timeline() {
  return (
    <div className="timeline">
      {timelineItems.map(([label, text], index) => (
        <article className="timeline-item" key={label}>
          <span>{String(index + 1).padStart(2, "0")}</span>
          <h3>{label}</h3>
          <p>{text}</p>
        </article>
      ))}
    </div>
  );
}
